
import React, { Component } from 'react'
import { connect } from "react-redux";
import { Helmet } from 'react-helmet-async';
// intl messages
import IntlMessages from 'Util/IntlMessages'; 
// page title bar
import PageTitleBar from 'Components/PageTitleBar/PageTitleBar';

// app config
import AppConfig from 'Constants/AppConfig';
import { RctCard, RctCardContent } from 'Components/RctCard';

import {
   StudentsFullDetails,
   fetchRangeIronPlay,
   fetchRangeFairway,
   fetchRangeDriver,
   fetchRangeWedgePlay,
   fetchRangeChipping,
   fetchRangeBunkerPlay,
   fetchRangePutting,
   fetchCourseIntervention,
   fetchRangeSpeciality,
   fetchPlayerIntervention,
   studentTournamentScore,
   fetchTournamentProcessReport,
   student_all_practiceschedule,
} from 'Actions';

import GolfDashboard from './studentcomponent/golf/intervention/golfdashboard';
import GolfIntervention from './studentcomponent/golf/intervention/golfintervention';
import LongGame from './studentcomponent/golf/intervention/golflonggame';
import ShortGame from './studentcomponent/golf/intervention/golfshortgame';
import Putting from './studentcomponent/golf/intervention/golfputting';
import CourseIntervention from './studentcomponent/golf/intervention/golfcourseintervention';
import GolfRangeTest from './studentcomponent/golf/rangetest/onrangetest';
import GolfCourseTest from './studentcomponent/golf/oncoursetest/coursetest';
import GolfTournament from './studentcomponent/golf/tournamentdata';
import GolfTechnology from './studentcomponent/golf/technology/technologyreport';
import GolfPractice from './studentcomponent/golf/practiceschedule/practicemain';
import TravelDashboard from './studentcomponent/travel/studentinformation';

import SSDashboard from './studentcomponent/sportscience/ssdashboard';

import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';

class StudentDashbaord extends Component {

   constructor(props) {
     
      super(props);
      this.state = {   
         student: '',
         startdate:'',
         enddate:'',      
         sudentdiv:false,
         golfdiv:false, 
         sportsciencediv:false, 
         traveldiv:false,
         golfintervention:false,
         golflonggame:false,
         golfshortgame:false,
         golfputting:false,
         golfcourseinter:false,
         golfonrange:false,
         golfoncourse:false,
         golftournament:false,
         golftechnology:false,
         golfpractice:false,
         practdata:0,
         studentname:'', 
      };      
      
      this.onMainSection = this.onMainSection.bind(this);
      this.onGolfsection = this.onGolfsection.bind(this);
      this.onGolfBackSection = this.onGolfBackSection.bind(this);
      this.onInterventsection = this.onInterventsection.bind(this);
   }

   UNSAFE_componentWillMount() {
     var stdrole = localStorage.getItem('stdrole');
     var role=localStorage.getItem('user_role'); 
      if(stdrole==1){ 
         var stdid=localStorage.getItem('user_id');   
         var studname='';
      }else{
         var stdid=this.props.data.selStudent; 
         var studname=this.props.data.studentname;
      }
      this.setState({ 
         student:stdid,
         studentname: studname
      });
     this.props.StudentsFullDetails(stdid);
     var start='';
     var end='';
     this.props.fetchPlayerIntervention(stdid, start, end).then((data) => {  

         if(role==5 || role==6){
            this.setState({ 
               sudentdiv:false,
               golfintervention:false,
               sportsciencediv:false,
               traveldiv:false,
               golfdiv:true,
            });
         }else{
            this.setState({ 
               sudentdiv:true,
               golfdiv:false, 
            });
         }
     });

     
   }

   selectdashboard(event,id){
      event.preventDefault();
      if(id==1){
         this.setState({ 
            sudentdiv:false,
            golfintervention:false,
            sportsciencediv:false,
            traveldiv:false,
            golfdiv:true,
         });
      }else if(id==2){
         this.setState({ 
            sudentdiv:false,
            golfintervention:false,
            golfdiv:false,
            traveldiv:false,
            sportsciencediv:true,
         });
      }else if(id==3){         
         this.setState({ 
            sudentdiv:false,
            golfintervention:false,
            golfdiv:false,
            sportsciencediv:false,
            traveldiv:true,
         });
      }
   }

  
   onMainSection() {
      var role=localStorage.getItem('user_role');
      
		this.setState({ 
         golfcourseinter:false,
         golfputting:false,
         golfshortgame:false,
         golflonggame:false,
         golfdiv:false,
         golfintervention:false,
         golfonrange:false,
         golfoncourse:false,
         golftournament:false,
         golftechnology:false,
         sportsciencediv:false,
         traveldiv:false,
         sudentdiv:true,  
      });

      if(role==5 || role==6){
         this.setState({  
            sudentdiv:false, 
            golfdiv:true, 
         });
      }else{
         this.setState({  
            sudentdiv:true,  
         });
      }
	} 

   onGolfsection(id){
      var student=this.state.student;
      var stdate="";
      var eddate="";
      var tournament="";
      var round="";
      if(id==1){         
         this.setState({ 
            golfdiv:false,         
            sudentdiv:false,  
            golfonrange:false, 
            golfoncourse:false, 
            golftournament:false,
            golfpractice:false,
            golfintervention:true,      
         });
      }else if(id==2){
         this.props.student_all_practiceschedule(student, stdate, eddate).then((data) => {              
            var resdata=data.data;
            if(resdata.length==1){
               var practdata=1;
            }else{
               var practdata=0;
            }
            
             
            this.setState({ 
               practdata:practdata,
               golfdiv:false,         
               sudentdiv:false,  
               golfonrange:false, 
               golfoncourse:false, 
               golftournament:false,
               golfintervention:false, 
               golfpractice:true,      
            });
         }); 
           
         
      }else if(id==3){
         this.setState({ 
            golfdiv:false,         
            sudentdiv:false,   
            golfintervention:false, 
            golfoncourse:false,   
            golftournament:false,
            golfpractice:false,
            golfonrange:true,   
         });
      }else if(id==4){
         this.setState({ 
            golfdiv:false,         
            sudentdiv:false,   
            golfintervention:false, 
            golfonrange:false,  
            golftournament:false,
            golfpractice:false,
            golfoncourse:true,  
         });
      }else if(id==5){
         this.props.fetchTournamentProcessReport(student, stdate, eddate, tournament, round);
         this.props.studentTournamentScore(student, stdate, eddate);
         this.setState({ 
            golfdiv:false,         
            sudentdiv:false,   
            golfintervention:false, 
            golfonrange:false,  
            golfpractice:false,
            golftournament:true,
            golfoncourse:false,  
         });
      }else if(id==6){
         this.setState({ 
            golfdiv:false,         
            sudentdiv:false,   
            golfintervention:false, 
            golfonrange:false,  
            golftournament:false,
            golfpractice:false,
            golfoncourse:false,  
            golftechnology:true,  
         });
      }
   }

   onGolfBackSection(id){
      var student=this.state.student;
      this.props.fetchPlayerIntervention(student, '', '').then((data) => {  
            if(id==1){
               this.setState({ 
                  golfdiv:true,         
                  sudentdiv:false,   
                  golfonrange:false,
                  golfintervention:false, 
                  golftournament:false, 
                  golfoncourse:false,  
                  golftechnology:false, 
                  golfpractice:false,   
               });
            }else if(id==2){
               this.setState({ 
                  golfdiv:false,         
                  sudentdiv:false,   
                  golfintervention:true, 
                  golflonggame:false,
                  golfshortgame:false,
                  golfputting:false,
                  golfcourseinter:false,
                  golfpractice:false,
               });
            }
      });
   }

   onInterventsection(id){
      var student=this.state.student;
      var stdate=this.state.startdate;
      var eddate=this.state.enddate;

      if(id==1){
         this.props.fetchRangeIronPlay(student, stdate, eddate);
         this.props.fetchRangeFairway(student, stdate, eddate);
         this.props.fetchRangeDriver(student, stdate, eddate);
         this.props.fetchRangeSpeciality(student, stdate, eddate);
         this.setState({ 
            golfdiv:false,         
            sudentdiv:false,   
            golfintervention:false, 
            golfshortgame:false, 
            golfputting:false,
            golfcourseinter:false,
            golflonggame:true,    
         });
      }else if(id==2){
            this.props.fetchRangeWedgePlay(student, stdate, eddate);
            this.props.fetchRangeChipping(student, stdate, eddate);
            this.props.fetchRangeBunkerPlay(student, stdate, eddate);
            this.setState({ 
               golfdiv:false,         
               sudentdiv:false,   
               golfintervention:false,  
               golflonggame:false, 
               golfputting:false,
               golfcourseinter:false,
               golfshortgame:true,   
            });
      }else if(id==3){
            this.props.fetchRangePutting(student, stdate, eddate);
            this.setState({ 
               golfdiv:false,         
               sudentdiv:false,   
               golfintervention:false,  
               golflonggame:false,
               golfshortgame:false,  
               golfcourseinter:false,
               golfputting:true,                 
            });
      }else if(id==4){
            this.props.fetchCourseIntervention(student);
            this.setState({ 
               golfdiv:false,         
               sudentdiv:false,   
               golfintervention:false,  
               golflonggame:false,
               golfshortgame:false,  
               golfputting:false,
               golfcourseinter:true,                 
            });
      }
   }

   render() {
      const { match } = this.props;
      const { studentfulldetails, playerinterventionlist, loading } = this.props;
      const stdrole = localStorage.getItem('stdrole');
      const role =  localStorage.getItem('user_role');
      return (
         <div className="saas-dashboard">
            <Helmet>
               <title>Dashboard | {AppConfig.appTitle}</title>
               <meta name="description" content="Reactify Sass Dashboard" />
            </Helmet>
            
           
            {this.state.sudentdiv &&                    
                  
                 <div className="row">
                  {stdrole!=1 ?  
                     <div className="col-md-12">
                        <div className="float-right">
                           <button class="mr-3 mb-3 btn btn-outline-warning btn-sm float-right" onClick={e => this.props.onClick(e, 2)}><KeyboardDoubleArrowLeftIcon aria-hidden="true" /> Back</button>
                        </div>
                     </div> 
                  :
                     ''
                  }
                     <div className="col-sm-12 col-lg-3">
                        <div className="text-center studendet">
                        <img
                           src={AppConfig.apiurl+'/theme/img/profile_images/'+studentfulldetails.uud_profileimage}
                           alt="Student Profile" style={{width:"60%", height:"60%"}}
                        />
                        <div><strong>{studentfulldetails.uud_firstName+" "+studentfulldetails.uud_lastName}</strong></div>
                        </div>
                        <div className="text-center"></div>
                     </div> 
                     <div className="col-sm-12 col-lg-3">
                        <RctCard>
                              <RctCardContent>
                                 <a onClick={(e) => this.selectdashboard(e,1)}>
                                 <img src={require('Assets/img/dashboard/dash_golf.jpg')} className="img-fluid" alt="site-logo" />
                                 <button class="btn btn-primary btn-block">GOLF</button>
                                 </a>
                              </RctCardContent>
                        </RctCard>      
                     </div> 
                     <div className="col-sm-12 col-lg-3">
                        <RctCard>
                              <RctCardContent>
                                 <a onClick={(e) => this.selectdashboard(e,2)}>
                                 <img src={require('Assets/img/dashboard/dash_ss.jpg')} className="img-fluid" alt="site-logo" />
                                 <button class="btn btn-primary btn-block" >SPORT SCIENCE</button>
                                 </a>
                              </RctCardContent>
                        </RctCard> 
                     </div> 
                     <div className="col-sm-12 col-lg-3">
                        <RctCard>
                              <RctCardContent>        
                              <a onClick={(e) => this.selectdashboard(e,3)}>                      
                              <img src={require('Assets/img/dashboard/dash_res.jpg')} className="img-fluid" alt="site-logo" />
                              <button class="btn btn-primary btn-block">STUDENT INFORMATION</button>
                              </a>
                              </RctCardContent>
                        </RctCard> 
                     </div> 
                    
                 </div>
           } 
           {/* ============= Golf Platform ======================= */}
           {this.state.golfdiv &&
            <>
               <div className="studentheading"><h2 className="text-center"><strong>{this.state.studentname}</strong></h2></div>
               <div className="row" style={{marginBottom:"20px"}}>
                  <div className="col-lg-2"><div className="float-left"><button class="mr-3 mb-3 btn btn-info btn-sm float-left" onClick={() => this.onMainSection()}><HomeOutlinedIcon aria-hidden="true" /> Main</button></div></div>
                  <div className="col-lg-8"><h2 className="text-center">GOLF DASHBOARD</h2></div>
                  <div className="col-lg-2">
                        {role==5 ? 
                        <div className="float-right">
                           <button class="mr-3 mb-3 btn btn-outline-warning btn-sm float-right" onClick={e => this.props.onClick(e, 2)}><KeyboardDoubleArrowLeftIcon aria-hidden="true" /> Back</button>
                        </div>
                        :''}

                  </div>
               </div>
               <GolfDashboard onClick={this.onGolfsection}/>
            </>
           }
           {/* ============= Intervention ======================= */}
           {this.state.golfintervention &&
            <>
               <div className="studentheading"><h2 className="text-center"><strong>{this.state.studentname}</strong></h2></div>
               <div className="row" style={{marginBottom:"20px"}}>
                  <div className="col-lg-2"><div className="float-left"><button class="mr-3 mb-3 btn btn-info btn-sm float-left" onClick={() => this.onMainSection()}><HomeOutlinedIcon aria-hidden="true" /> Main</button></div></div>
                  <div className="col-lg-8"><h2 className="text-center">INTERVENTIONS</h2></div>
                  <div className="col-lg-2"><div className="float-right"><button class="mr-3 mb-3 btn btn-outline-warning btn-sm float-right" onClick={() => this.onGolfBackSection(1)}><KeyboardDoubleArrowLeftIcon aria-hidden="true" /> Back</button></div></div>
               </div>
               <GolfIntervention onClick={this.onInterventsection}/>
            </>
           }

           {this.state.golflonggame &&
            <>
               <div className="studentheading"><h2 className="text-center"><strong>{this.state.studentname}</strong></h2></div>
               <div className="row" style={{marginBottom:"20px"}}>
                  <div className="col-lg-2"><div className="float-left"><button class="mr-3 mb-3 btn btn-info btn-sm float-left" onClick={() => this.onMainSection()}><HomeOutlinedIcon aria-hidden="true" /> Main</button></div></div>
                  <div className="col-lg-8"><h2 className="text-center">LONG GAME</h2></div>
                  <div className="col-lg-2"><div className="float-right"><button class="mr-3 mb-3 btn btn-outline-warning btn-sm float-right" onClick={() => this.onGolfBackSection(2)}><KeyboardDoubleArrowLeftIcon aria-hidden="true" /> Back</button></div></div>
               </div>
               <LongGame data={this.state}/>
            </>
           }
           {this.state.golfshortgame &&
            <>
               <div className="studentheading"><h2 className="text-center"><strong>{this.state.studentname}</strong></h2></div>
               <div className="row" style={{marginBottom:"20px"}}>
                  <div className="col-lg-2"><div className="float-left"><button class="mr-3 mb-3 btn btn-info btn-sm float-left" onClick={() => this.onMainSection()}><HomeOutlinedIcon aria-hidden="true" /> Main</button></div></div>
                  <div className="col-lg-8"><h2 className="text-center">SHORT GAME</h2></div>
                  <div className="col-lg-2"><div className="float-right"><button class="mr-3 mb-3 btn btn-outline-warning btn-sm float-right" onClick={() => this.onGolfBackSection(2)}><KeyboardDoubleArrowLeftIcon aria-hidden="true" /> Back</button></div></div>
               </div>
               <ShortGame data={this.state}/>
            </>
           }
           {this.state.golfputting &&
            <>
               <div className="studentheading"><h2 className="text-center"><strong>{this.state.studentname}</strong></h2></div>
               <div className="row" style={{marginBottom:"20px"}}>
                  <div className="col-lg-2"><div className="float-left"><button class="mr-3 mb-3 btn btn-info btn-sm float-left" onClick={() => this.onMainSection()}><HomeOutlinedIcon aria-hidden="true" /> Main</button></div></div>
                  <div className="col-lg-8"><h2 className="text-center">PUTTING</h2></div>
                  <div className="col-lg-2"><div className="float-right"><button class="mr-3 mb-3 btn btn-outline-warning btn-sm float-right" onClick={() => this.onGolfBackSection(2)}><KeyboardDoubleArrowLeftIcon aria-hidden="true" /> Back</button></div></div>
               </div>
               <Putting data={this.state}/>
            </>
           }
           {this.state.golfcourseinter &&
            <>
               <div className="studentheading"><h2 className="text-center"><strong>{this.state.studentname}</strong></h2></div>
               <div className="row" style={{marginBottom:"20px"}}>
                  <div className="col-lg-2"><div className="float-left"><button class="mr-3 mb-3 btn btn-info btn-sm float-left" onClick={() => this.onMainSection()}><HomeOutlinedIcon aria-hidden="true" /> Main</button></div></div>
                  <div className="col-lg-8"><h2 className="text-center">COURSE INTERVENTION</h2></div>
                  <div className="col-lg-2"><div className="float-right"><button class="mr-3 mb-3 btn btn-outline-warning btn-sm float-right" onClick={() => this.onGolfBackSection(2)}><KeyboardDoubleArrowLeftIcon aria-hidden="true" /> Back</button></div></div>
               </div>
               <CourseIntervention data={this.state}/>
            </>
           }
           {/* ============= On Range Test ======================= */}
           {this.state.golfonrange &&
            <> 
               <div className="studentheading"><h2 className="text-center"><strong>{this.state.studentname}</strong></h2></div>              
               <GolfRangeTest onClick={this.onMainSection} onClick1={this.onGolfBackSection} data={this.state}/>
            </>
           }
           {/* ============= On Course Test ======================= */}
           {this.state.golfoncourse &&
            <>   
               <div className="studentheading"><h2 className="text-center"><strong>{this.state.studentname}</strong></h2></div>            
               <GolfCourseTest onClick={this.onMainSection} onClick1={this.onGolfBackSection} data={this.state}/>
            </>
           }
           {/* ============= Tournament Data ======================= */}
           {this.state.golftournament &&
            <>    
               <div className="studentheading"><h2 className="text-center"><strong>{this.state.studentname}</strong></h2></div>           
               <GolfTournament onClick={this.onMainSection} onClick1={this.onGolfBackSection} data={this.state}/>
            </>
           }
           {/* ============= Technology ======================= */}
           {this.state.golftechnology &&
            <>     
               <div className="studentheading"><h2 className="text-center"><strong>{this.state.studentname}</strong></h2></div>          
               <GolfTechnology onClick={this.onMainSection} onClick1={this.onGolfBackSection} data={this.state}/>
            </>
           }

           {/* ============= Practice Schedule ======================= */}
           {this.state.golfpractice &&
            <>     
               <div className="studentheading"><h2 className="text-center"><strong>{this.state.studentname}</strong></h2></div>          
               <GolfPractice onClick={this.onMainSection} onClick1={this.onGolfBackSection} data={this.state}/>
            </>
           }

           {/* ============= Sport Platform ======================= */}
           {this.state.sportsciencediv &&
            <> 
               <div className="studentheading"><h2 className="text-center"><strong>{this.state.studentname}</strong></h2></div>
               <SSDashboard onClick={this.onMainSection}/>
            </>
           }

           {/* ============= Student Information Platform ======================= */}
           {this.state.traveldiv &&
               <>
                  <div className="studentheading"><h2 className="text-center"><strong>{this.state.studentname}</strong></h2></div>
                  <div className="row" style={{marginBottom:"20px"}}>
                     <div className="col-lg-2"><div className="float-left"><button class="mr-3 mb-3 btn btn-info btn-sm float-left" onClick={() => this.onMainSection()}><HomeOutlinedIcon aria-hidden="true" /> Main</button></div></div>
                     <div className="col-lg-8"><h2 className="text-center">STUDENT INFORMATION</h2></div>
                     <div className="col-lg-2"></div>
                  </div>
                  <TravelDashboard onClick={this.onMainSection} data={this.state}/>
               </>
           }




        </div>
      )
   }
}

const mapStateToProps = ({ mostlyused, playerintervention }) => {

   const { studentfulldetails, loading } = mostlyused;
   const { playerinterventionlist } = playerintervention;
   return { studentfulldetails, playerinterventionlist, loading };
}

export default connect(mapStateToProps, {

   StudentsFullDetails,
   fetchRangeIronPlay,
   fetchRangeFairway,
   fetchRangeDriver,
   fetchRangeWedgePlay,
    fetchRangeChipping,
    fetchRangeBunkerPlay,
    fetchRangePutting,
    fetchCourseIntervention,
   fetchRangeSpeciality,
   fetchPlayerIntervention,
   studentTournamentScore,
   fetchTournamentProcessReport,
   student_all_practiceschedule,
})(StudentDashbaord); 
